import React from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'

export default function MogulPerson(props) {
  const { personInfo } = props
  return (
    <div className={styles.PersonInfoContainer}>
      <div>
        <div className={styles.PersonTop}>
          <div className={styles.PersonTopInfoTitle}>
            <h4>{personInfo.profession}</h4>
            <h4>{personInfo.profession}</h4>
          </div>
          <div>
            <p>
              <span>姓名：</span>
              <span>{personInfo.name}</span>
            </p>
            <p>
              <span>经历：</span>
              <span>{personInfo.desc}</span>
            </p>
          </div>
        </div>
        <div className={styles.PersonDesc}>
          <img src="https://tc-cdn.123u.com/official-website/company/quotation_left.png" draggable="false"></img>
          <pre>{personInfo.idea}</pre>
          <img src="https://tc-cdn.123u.com/official-website/company/quotation_right.png" draggable="false"></img>
        </div>
      </div>
      <div style={{ backgroundImage: `url(${personInfo.img})` }}></div>
    </div>
  )
}

MogulPerson.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  personInfo: PropTypes.object.isRequired,
}
